/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFStatsResponse
 */
export interface CRSFStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFStatsResponse
     */
    assets_count: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFStatsResponse
     */
    claims_benchmark: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof CRSFStatsResponse
     */
    created: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFStatsResponse
     */
    dataleaks_count: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFStatsResponse
     */
    process_id: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFStatsResponse
     */
    surface: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFStatsResponse
     */
    vulnerabilities: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof CRSFStatsResponse
     */
    vulnerabilities_count: number;
}

/**
 * Check if a given object implements the CRSFStatsResponse interface.
 */
export function instanceOfCRSFStatsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assets_count" in value;
    isInstance = isInstance && "claims_benchmark" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "dataleaks_count" in value;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "surface" in value;
    isInstance = isInstance && "vulnerabilities" in value;
    isInstance = isInstance && "vulnerabilities_count" in value;

    return isInstance;
}

export function CRSFStatsResponseFromJSON(json: any): CRSFStatsResponse {
    return CRSFStatsResponseFromJSONTyped(json, false);
}

export function CRSFStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFStatsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assets_count': json['assets_count'],
        'claims_benchmark': json['claims_benchmark'],
        'created': json['created'],
        'dataleaks_count': json['dataleaks_count'],
        'process_id': json['process_id'],
        'surface': json['surface'],
        'vulnerabilities': json['vulnerabilities'],
        'vulnerabilities_count': json['vulnerabilities_count'],
    };
}

export function CRSFStatsResponseToJSON(value?: CRSFStatsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assets_count': value.assets_count,
        'claims_benchmark': value.claims_benchmark,
        'created': value.created,
        'dataleaks_count': value.dataleaks_count,
        'process_id': value.process_id,
        'surface': value.surface,
        'vulnerabilities': value.vulnerabilities,
        'vulnerabilities_count': value.vulnerabilities_count,
    };
}

